<script lang="ts" setup>
    import { computed, ref } from 'vue'

    const props = defineProps<{
        src: string
        altSrc?: string
        blankOnError?: boolean
    }>()
    const errorStage = ref<'none' | 'primary' | 'secondary'>('none')
    const onError = () => {
        if (errorStage.value === 'none') {
            errorStage.value = 'primary'
        } else if (errorStage.value === 'primary' && props.altSrc) {
            errorStage.value = 'secondary'
        }
    }
    const hasSrc = computed(() => {
        if (errorStage.value === 'none') {
            return props.src
        }
        if (errorStage.value === 'primary' && props.altSrc) {
            return props.altSrc
        }
        if (props.blankOnError) {
            return 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=='
        }
        return undefined
    })
    const hasStyle = computed(() => {
        return {
            display: !hasSrc.value ? 'none' : undefined,
        }
    })
</script>

<template>
    <img :src="hasSrc" loading="lazy" :style="hasStyle" @error="onError" />
</template>
